import React, { useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Funciona si la ruptura fue hace mucho tiempo?',
    a: 'Sí, el apego no entiende de tiempo, sino de circuitos neuronales activos.'
  }, {
    q: '¿Tengo que borrar mis fotos?',
    a: 'El protocolo te enseñará cuándo y cómo gestionar los anclajes físicos sin morir en el intento.'
  }, {
    q: '¿Es un libro físico?',
    a: 'Es un producto digital de descarga inmediata para que empieces tu recuperación hoy mismo.'
  }];
  return <section className="py-16 md:py-24 px-4 bg-brand-dark" data-id="element-26">
      <div className="max-w-2xl mx-auto" data-id="element-27">
        <FadeIn data-id="element-28">
          <h3 className="font-serif text-3xl md:text-4xl text-white text-center mb-12" data-id="element-29">
            Preguntas Frecuentes
          </h3>
        </FadeIn>

        <div className="space-y-4" data-id="element-30">
          {faqs.map((faq, i) => <FAQItem key={i} question={faq.q} answer={faq.a} delay={i * 0.1} data-id="element-31" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer,
  delay
}: {
  question: string;
  answer: string;
  delay: number;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <FadeIn delay={delay} data-id="element-32">
      <div className="border border-white/10 rounded-xl overflow-hidden bg-[#1e293b]/50" data-id="element-33">
        <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-34">
          <span className="text-white font-medium pr-4" data-id="element-35">{question}</span>
          <motion.div animate={{
          rotate: isOpen ? 180 : 0
        }} transition={{
          duration: 0.2
        }} data-id="element-36">
            <ChevronDown className="w-5 h-5 text-brand-amber flex-shrink-0" data-id="element-37" />
          </motion.div>
        </button>
        <AnimatePresence data-id="element-38">
          {isOpen && <motion.div initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={{
          duration: 0.3,
          ease: 'easeInOut'
        }} data-id="element-39">
              <div className="px-6 pb-5 text-brand-text/80 leading-relaxed" data-id="element-40">
                {answer}
              </div>
            </motion.div>}
        </AnimatePresence>
      </div>
    </FadeIn>;
}